// extracted by mini-css-extract-plugin
export default {"item":"kdsScreens_item__0sBxo","modifiers":"kdsScreens_modifiers__fhgW3"};